var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-picker-field"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('el-date-picker',_vm._b({class:( _obj = {}, _obj[_vm.theme] = _vm.theme, _obj ),attrs:{"id":_vm.id,"picker-options":_vm.pickerOptions,"value":_vm.value,"type":"date"},on:{"input":_vm.input}},'el-date-picker',_vm.rest,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }